export const ACCESS_TOKEN = "access_token";
export const ID_TOKEN = "id_token";
export const REFRESH_TOKEN = "refresh_token";
export const EXPIRES_TIME = "expires_time";
export const CODE = "code";
export const CODE_VERIFIER = "code_verifier";
export const NONCE = "nonce";
export const STATE = "state";

function cookieAttrs(): string {
  if (typeof window === "undefined") return "path=/";
  const secure =
    window.location.protocol === "https:"
      ? "; Secure; SameSite=None"
      : "; SameSite=Lax";
  return `path=/${secure}`;
}

export function getCookieByKey(key: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function setSecureCookie(key: string, value: string): void {
  if (typeof document === "undefined") return;
  document.cookie = `${key}=${encodeURIComponent(value)}; ${cookieAttrs()}`;
}

export function removeCookie(key: string): void {
  if (typeof document === "undefined") return;
  document.cookie = `${key}=; path=/; Max-Age=0`;
}

export function performRemoveCookies(): void {
  removeCookie(ACCESS_TOKEN);
  removeCookie(ID_TOKEN);
  removeCookie(REFRESH_TOKEN);
  removeCookie(EXPIRES_TIME);
  removeCookie(CODE);
}
